/**
 * Wishlist
 * Simple localStorage-backed wishlist used by the product card heart button,
 * the header wishlist icon, and the mobile bottom nav wishlist icon.
 */
(function () {
  var STORAGE_KEY = 'spoilt_wishlist_items';
  // Only used if the drawer has no data-money-format attribute. Normally the
  // drawer mirrors the store's own currency format from the Shopify admin.
  var DEFAULT_MONEY_FORMAT = 'Tk {{amount}}';

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable (private mode, etc). Fail silently. */
    }
  }

  function isWishlisted(id) {
    if (!id) return false;
    var list = getWishlist();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return true;
    }
    return false;
  }

  function toggle(id, handle, title, source) {
    if (!id) return false;
    var list = getWishlist();
    var existingIndex = -1;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) {
        existingIndex = i;
        break;
      }
    }

    var nowActive;
    var knownHandle = handle || '';
    if (existingIndex > -1) {
      knownHandle = knownHandle || list[existingIndex].handle || '';
      list.splice(existingIndex, 1);
      nowActive = false;
    } else {
      list.push({ id: id, handle: handle || '' });
      nowActive = true;
    }

    saveWishlist(list);
    updateCountUI();
    window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: list.length } }));
    trackWishlist(nowActive, id, knownHandle, title, source, list.length);
    return nowActive;
  }

  // Tells the SPOILT tracking pixel (Shopify custom pixel) about a favourite add/remove.
  // Fails silently: tracking must never break the wishlist.
  function trackWishlist(added, id, handle, title, source, count) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('sp_wishlist', {
          action: added ? 'add' : 'remove',
          product_id: String(id),
          handle: handle || '',
          title: title || '',
          source: source || 'card',
          count: count
        });
      }
    } catch (e) { /* ignore */ }
  }

  function cleanText(el) {
    return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 150) : '';
  }

  // Best-effort product name for a heart button on a product card.
  function cardTitle(btn) {
    var card = btn.closest('.card-wrapper, .card, .product-card-wrapper, li, article');
    return cleanText(card && card.querySelector('.card__heading, .card__title, h3, h2'));
  }

  function drawerTitle(btn) {
    var row = btn.closest('.wishlist-drawer__item');
    return cleanText(row && row.querySelector('.wishlist-drawer__item-title'));
  }

  function updateCountUI() {
    var count = getWishlist().length;
    var countEls = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < countEls.length; i++) {
      countEls[i].textContent = count;
    }
    var bubbleEls = document.querySelectorAll('[data-wishlist-count-bubble]');
    for (var j = 0; j < bubbleEls.length; j++) {
      bubbleEls[j].hidden = count === 0;
    }
  }

  function refreshButtonStates() {
    var buttons = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var id = btn.getAttribute('data-product-id');
      var active = isWishlisted(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function getDrawer() {
    return document.querySelector('[data-wishlist-drawer]');
  }

  function renderDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;

    var listEl = drawer.querySelector('[data-wishlist-items]');
    var emptyEl = drawer.querySelector('[data-wishlist-empty]');
    if (!listEl) return;

    var items = getWishlist();

    if (items.length === 0) {
      listEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    listEl.innerHTML = '<div class="wishlist-drawer__loading">Loading&hellip;</div>';

    var fetches = items.map(function (item) {
      if (!item.handle) return Promise.resolve(null);
      return fetch('/products/' + encodeURIComponent(item.handle) + '.js')
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .catch(function () {
          return null;
        });
    });

    Promise.all(fetches).then(function (products) {
      // Guard against the drawer having been closed/reopened while fetching.
      var currentDrawer = getDrawer();
      if (!currentDrawer) return;
      var currentList = currentDrawer.querySelector('[data-wishlist-items]');
      if (!currentList) return;

      currentList.innerHTML = '';
      var renderedAny = false;

      products.forEach(function (product, index) {
        if (!product) return;
        renderedAny = true;
        var item = items[index];
        var image = product.featured_image || (product.images && product.images[0]) || '';
        var priceHtml = formatMoney(product.price);
        var variant = null;
        if (product.variants && product.variants.length) {
          for (var v = 0; v < product.variants.length; v++) {
            if (product.variants[v].available) {
              variant = product.variants[v];
              break;
            }
          }
          if (!variant) variant = product.variants[0];
        }
        var variantId = variant ? variant.id : '';
        var canAdd = variant && variant.available;
        var handle = encodeURIComponent(product.handle);

        var row = document.createElement('div');
        row.className = 'wishlist-drawer__item';
        row.innerHTML =
          '<a href="/products/' + handle + '" class="wishlist-drawer__item-image">' +
          '<img src="' + escapeAttr(image) + '" alt="' + escapeAttr(product.title) + '" loading="lazy" width="64" height="64">' +
          '</a>' +
          '<div class="wishlist-drawer__item-info">' +
          '<a href="/products/' + handle + '" class="wishlist-drawer__item-title">' + escapeHtml(product.title) + '</a>' +
          '<div class="wishlist-drawer__item-price">' + priceHtml + '</div>' +
          (canAdd
            ? '<button type="button" class="button button--small wishlist-drawer__item-add" data-wishlist-add-to-cart="' + escapeAttr(variantId) + '">Add to cart</button>'
            : '<span class="wishlist-drawer__item-price" style="opacity:.6;">Sold out</span>') +
          '</div>' +
          '<button type="button" class="wishlist-drawer__item-remove" data-wishlist-remove="' + escapeAttr(item.id) + '" aria-label="Remove from wishlist">&times;</button>';
        currentList.appendChild(row);
      });

      if (!renderedAny) {
        currentList.innerHTML = '';
        var currentEmpty = currentDrawer.querySelector('[data-wishlist-empty]');
        if (currentEmpty) currentEmpty.hidden = false;
      }
    });
  }

  /* ---- Money formatting -------------------------------------------------
     /products/<handle>.js returns prices in minor units (poisha), so
     395000 means Tk 3,950.00. We format them with the store's own money
     format (Shopify admin > Settings > Store details > Standard and
     currency formatting) so the wishlist matches the rest of the store.
     The old fallback hard-coded a "$" sign, which is why prices looked
     like US dollars here. */
  function moneyWithDelimiters(cents, precision, thousands, decimal) {
    var value = Number(cents);
    if (!isFinite(value)) return '0';
    var fixed = (value / 100).toFixed(precision);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function getMoneyFormat() {
    var drawer = getDrawer();
    var fromDrawer = drawer && drawer.getAttribute('data-money-format');
    return fromDrawer || window.theme_money_format || DEFAULT_MONEY_FORMAT;
  }

  function formatMoney(cents) {
    var format = getMoneyFormat();
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = moneyWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = moneyWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = moneyWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = moneyWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = moneyWithDelimiters(cents, 0, ' ', '.');
        break;
      case 'amount_with_space_separator':
        value = moneyWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = moneyWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = moneyWithDelimiters(cents, 2, ',', '.');
    }
    return format.replace(match[0], value);
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-mobile-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('[data-mobile-cart-badge]').forEach(function (el) {
          el.hidden = cart.item_count === 0;
        });
        var desktopCountSpan = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
        if (desktopCountSpan) {
          desktopCountSpan.textContent = cart.item_count;
        }
      })
      .catch(function () {
        /* non-critical: badges just won't refresh this time */
      });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : str;
    return div.innerHTML;
  }

  // For values placed inside HTML attributes (also escapes quotes).
  function escapeAttr(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    renderDrawer();
    drawer.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('active');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      var id = toggleBtn.getAttribute('data-product-id');
      var handle = toggleBtn.getAttribute('data-product-handle');
      toggle(id, handle, cardTitle(toggleBtn), 'card');
      refreshButtonStates();
      return;
    }

    var openBtn = e.target.closest('[data-wishlist-open]');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }

    var closeBtn = e.target.closest('[data-wishlist-close]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      e.preventDefault();
      var removeId = removeBtn.getAttribute('data-wishlist-remove');
      toggle(removeId, null, drawerTitle(removeBtn), 'drawer');
      refreshButtonStates();
      renderDrawer();
      return;
    }

    var addBtn = e.target.closest('[data-wishlist-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      var variantId = addBtn.getAttribute('data-wishlist-add-to-cart');
      if (!variantId || addBtn.disabled) return;
      var originalText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data && data.description ? data.description : 'Could not add to cart');
            return data;
          });
        })
        .then(function () {
          addBtn.textContent = 'Added';
          refreshCartCount();
          setTimeout(function () {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          addBtn.textContent = 'Try again';
          addBtn.disabled = false;
          setTimeout(function () {
            addBtn.textContent = originalText;
          }, 1500);
        });
      return;
    }

    var overlay = e.target.closest('[data-wishlist-overlay]');
    if (overlay) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateCountUI();
    refreshButtonStates();
  });

  window.Wishlist = {
    getWishlist: getWishlist,
    toggle: toggle,
    isWishlisted: isWishlisted,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer,
  };
})();